import React from "react";
import { useContext } from "react";
import { IconButton, Stack, Typography } from "@mui/material";
import { QuestionsContext, ShowPageContext } from "../../../provider/MyContexts";
import { color, pages } from "../../../config";
import { Home } from "@mui/icons-material";

type Props = {
  children: React.ReactNode;
};

export default function PageLayout(props: Props) {
  const { showPage, setShowPage } = useContext(ShowPageContext);

  const { selectedSheet } = useContext(QuestionsContext);

  return (
    <Stack flex={1} width={"100%"}>
      <Stack
        // direction={"column"}
        // justifyContent={"start"}
        marginBottom={1}
        direction="row"
        alignItems="center"
        justifyContent={"space-between"}
        sx={{
          // position: "sticky",
          // top: 0,
          // zIndex: 1,
          backgroundColor: color.background,
        }}
      >
        {/* <Button
          variant="text"
          sx={{ width: 100, textDecoration: "none" }}
          onClick={() => setShowPage("top")}
        >
          <KeyboardDoubleArrowLeftIcon />
          <Typography variant="body_S">Topに戻る</Typography>
        </Button> */}
        {/* <Stack  spacing={0.25}> */}
        {/* パンくずリスト */}
        {/* <Typography
            variant="label_M"
            sx={{
              "&:hover": { textDecoration: "underline" },
            }}
            onClick={() => setShowPage("top")}
          >
            Top
          </Typography>
          <NavigateNextIcon />
          <Typography variant="label_M" marginBottom={1}>
            {pages.find((page) => page.id === showPage)?.label}
          </Typography>
          <NavigateNextIcon />
          <Typography variant="label_M" marginBottom={1}>
            {selectedSheet}
          </Typography> */}
        <Typography variant="heading_L">
          {pages.find((page) => page.id === showPage)?.label}
        </Typography>
        <IconButton
          onClick={() => setShowPage("top")}
          sx={{
            marginBottom: 1,
          }}
        >
          <Home />
        </IconButton>
        {/* </Stack> */}
      </Stack>
      {props.children}
    </Stack>
  );
}
